// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2kcSV","vLegacy":"SelectSecondary_vLegacy__1JBJu","error":"SelectSecondary_error__1rQsk","disabled":"SelectSecondary_disabled__CV3FD"};